import { Breadcrumb } from "../ui/breadcrumb"

type BreadcrumbItem = {
  label: string
  to?: string
}

type Props = {
  items: BreadcrumbItem[]
}

/**
 * Odoo-namespaced breadcrumb adapter — delegates to the shared
 * `ui/Breadcrumb` so odoo-style detail pages render the same refined
 * trail as the rest of the app. Maps the legacy `{ to, label }` shape
 * to the ui primitive's `{ path, label }` shape.
 */
export function BreadcrumbNav({ items }: Props) {
  return <Breadcrumb items={items.map((i) => ({ label: i.label, path: i.to }))} />
}
